/* eslint-disable no-nested-ternary */
import React from 'react';
import { styled } from 'linaria/react';
import { useBreakpoint } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Partners, usePartner } from '@shared/lib/partner';
interface Props {
  title: string;
  onClick?: () => void;
  modal?: boolean;
  icon?: React.ReactElement;
}
const NoticeButton = ({
  title,
  onClick,
  modal,
  icon
}: Props) => {
  const {
    isMobile
  } = useBreakpoint();
  const {
    partner
  } = usePartner();
  return <ButtonWrapper onClick={onClick} isMobile={isMobile} modal={modal} partner={partner}>
      {icon && icon}
      <Text>{title}</Text>
    </ButtonWrapper>;
};
export default NoticeButton;
interface ButtonWrapperProps {
  isMobile: boolean;
  modal?: boolean;
  partner: Partners;
}
const _exp = /*#__PURE__*/() => ({
  modal,
  theme
}) => modal ? theme.colors.state.alternativeSecondary : theme.colors.resultButton.default;
const _exp4 = /*#__PURE__*/() => ({
  modal,
  partner,
  theme
}) => partner === Partners.SMARTSHELL ? 'none' : modal ? '0px 4px 0px 0px rgb(28,33,76)' : `0px 4px 0px 0px ${theme.colors.resultButton.shadow}`;
const _exp5 = /*#__PURE__*/() => ({
  isMobile,
  theme
}) => isMobile ? theme.colors.bg.tertiary : theme.colors.state.secondaryHover;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.secondaryTap;
const _exp7 = /*#__PURE__*/() => ({
  disabled,
  partner
}) => disabled || partner === Partners.SMARTSHELL ? 'none' : 'translateY(4px)';
const ButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "ButtonWrapper",
  class: "b1lwixqm",
  propsAsIs: false,
  vars: {
    "b1lwixqm-0": [_exp()],
    "b1lwixqm-1": [_exp4()],
    "b1lwixqm-2": [_exp5()],
    "b1lwixqm-3": [_exp6()],
    "b1lwixqm-4": [_exp7()]
  }
}));
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxxs;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxxs;
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.resultButton;
const Text = withTheme(/*#__PURE__*/styled('div')({
  name: "Text",
  class: "trmanbh",
  propsAsIs: false,
  vars: {
    "trmanbh-0": [_exp8()],
    "trmanbh-1": [_exp9(), "px"],
    "trmanbh-2": [_exp0()],
    "trmanbh-3": [_exp1(), "px"],
    "trmanbh-4": [_exp10()]
  }
}));

require("./NoticeButton.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./NoticeButton.tsx");